import { useEffect, useState } from "react";
import React from "react";
import httpClient from "services/network/httpClient";
import Crops from "./Crops";
import { Row } from "components/DataTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import GenericModal from "components/Modal";
import DeleteConfirmationModal from "components/Modal/DeleteConfirmationModal";
import AddCrops from "./AddCrops";
import EditCrops from "./EditCrops";
import { showToast } from "components/Toaster";
import { sortByName } from "utility/sorting";

interface CropActionCellProps {
  row: object;
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
}

const CropActionCell: React.FC<CropActionCellProps> = ({ row, onEdit, onDelete }) => (
  <div className="flex space-x-2">
    <button
      type="button"
      onClick={() => onEdit(row)}
      className="px-2 py-2 rounded-lg cursor-pointer"
      aria-label="Edit crop"
    >
      <FontAwesomeIcon icon={faEdit} />
    </button>
    <button
      type="button"
      onClick={() => onDelete(row)}
      className="px-2 py-2 rounded-lg cursor-pointer"
      aria-label="Delete crop"
    >
      <FontAwesomeIcon icon={faTrash} />
    </button>
  </div>
);

const CropList = () => {
  const [data, setData] = useState<Row[]>([]);
  const [isAdding, setIsAdding] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState<any>();
  const [isView, setIsView] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState<any>();

  const handleEdit = (row: any) => {
    setIsEdit(true);
    setEditData(row);
  };

  const handleDelete = (row: any) => {
    setDeleteData(row);
    setIsDelete(true);
  };
  const columnData = [
    {
      key: "cropName",
      label: "Crop Name",
    },
    {
      key: "actions",
      label: "Actions",
      excludeExport: true,
      actions: (row: object) => (
        <CropActionCell row={row} onEdit={handleEdit} onDelete={handleDelete} />
      ),
    },
  ];


  const getCrops = async () => {
    try {
      setLoading(true);

      const res: any = await httpClient.get("crop/all?page=1&size=2000");

      const contents = res?.value?.contents || [];

      // Sort first (if sortByName mutates, no need to assign)
      sortByName(contents, "cropName");

      const store = contents.map((crop: any) => ({
        id: crop.id,
        cropName: crop.cropName
          ? crop.cropName.charAt(0).toUpperCase() +
          crop.cropName.slice(1).toLowerCase()
          : "",
      }));

      setData(store);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCrops();
  }, []);

  const deleteFuction = () => {
    httpClient
      .delete(`crop/delete/${deleteData.id}?isDeleted=true`)
      .then((res) => {
        console.info("you are try to deleting");
        if (res.success === true) {
          getCrops();
          showToast("Crop Deleted Successfully", "success");
        } else {
          showToast(`${res.error.message}`, "error");
        }
        console.log(res);
      })
      .catch((error) => {
        console.info("Inside Error");
        showToast("Something went wrong", "error");
        console.log(error);
      })
      .finally(() => {
        console.info("you are in finally block");
        setIsDelete(false);
        getCrops();
      });
  };

  return (
    <div>
      <div className="">
        <div className="overflow-x-auto">
          <Crops
            data={data}
            columns={columnData}
            loading={loading}
            onAdd={() => setIsAdding(true)}
          ></Crops>
        </div>
      </div>
      {isAdding && (
        <GenericModal isOpen={isAdding} onClose={() => setIsAdding(false)} header="Add Crop " customWidth="md:w-96">
          <AddCrops
            onClose={() => setIsAdding(false)}
            getData={getCrops}

          ></AddCrops>
        </GenericModal>
      )}
      {isEdit && (
        <GenericModal
          isOpen={isEdit}
          onClose={() => setIsEdit(false)}
          header="Edit Crop Details "
          customWidth="md:w-96"
        >
          <EditCrops
            data={editData}
            getData={getCrops}
            onClose={() => setIsEdit(false)}
          ></EditCrops>
        </GenericModal>
      )}
      {isView && (
        <GenericModal isOpen={isView} onClose={() => setIsView(false)} >
          <button></button>
        </GenericModal>
      )}
      {isDelete && (
        <DeleteConfirmationModal
          isOpen={isDelete}
          onClose={() => setIsDelete(false)}
          onConfirm={deleteFuction}
          entityName="Crop"
          title="Delete Crop"
        />
      )}
    </div>
  );
};
export default CropList;
